import { setTicketBonusApi } from './graphql/userTicketBonusSetApi';
import { getBonusMonth, getDistrictId, getShowProcessed, getTicketId } from './selectors';
import { nextId } from '../../utils';
import { getUserDefaultDistrictId } from '../authentication/selectors';

export const types = {
  SET_DISTRICT_ID: 'bonuses/SET_DISTRICT_ID',
  SET_USER_ID: 'bonuses/SET_USER_ID',
  SET_TICKET_ID: 'bonuses/SET_TICKET_ID',
  SET_BONUS_MONTH: 'bonuses/SET_BONUS_MONTH',
  SET_SHOW_PROCESSED_TICKETS: 'bonuses/SET_SHOW_PROCESSED_TICKETS',
};

export const setDistrictId = (districtId) => {
  return {
    type: types.SET_DISTRICT_ID,
    districtId,
  };
};

export const setUserId = (userId) => {
  return {
    type: types.SET_USER_ID,
    userId,
  };
};

export const setTicketId = (ticketId) => {
  return {
    type: types.SET_TICKET_ID,
    ticketId,
  };
};

export const setBonusMonth = (monthDate) => {
  return {
    type: types.SET_BONUS_MONTH,
    bonusMonth: monthDate,
  };
};

export const setShowProcessedTickets = (showProcessed) => {
  return {
    type: types.SET_SHOW_PROCESSED_TICKETS,
    showProcessed,
  };
};

export const dispatchDistrict = (district) => {
  return setDistrictId(district.id);
};

export const setUserDefaultDistrictId = () => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const userDefaultDistrict = getUserDefaultDistrictId(state);
    dispatch(setDistrictId(userDefaultDistrict));
  };
};

export const advancedBonusTicketFiltering = (showProcessed, allBonusMonths) => {
  return async (dispatch, getState, { client }) => {
    dispatch(setShowProcessedTickets(showProcessed));
    const currentBonusMonth = allBonusMonths[0].iso8601;
    const defaultBonusMonth = (showProcessed) ? currentBonusMonth : null;
    dispatch(setBonusMonth(defaultBonusMonth));
  };
};

export const setTicketBonus = (userTicketBonusArray) => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const bonusMonth = getBonusMonth(state);
    const districtId = getDistrictId(state);
    const ticketId = getTicketId(state);
    const showProcessed = getShowProcessed(state);

    const { oldCollection } = await setTicketBonusApi(
      client,
      userTicketBonusArray,
      bonusMonth,
      districtId,
      showProcessed,
    );

    /* NOTE: the list of tickets had 1 left and it was processed
    * Before it was never hitting the else statement */
    if (oldCollection.length > 1) {
      const nextTicketId = nextId(oldCollection, ticketId);
      if (nextTicketId) {
        dispatch(setTicketId(nextTicketId));
      }
    } else {
      dispatch(setTicketId(null));
    }
  };
};
